import { HeadingPriority } from "atoms/constants/heading-priority";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import Heading from "atoms/typography/heading";
import Paragraph from "atoms/typography/paragraph";
import React from "react";
import { BookmarkUtils } from "utilities/bookmark-utils";
import { UserBookmarkColors } from "utilities/enumerations/user-bookmark-colors";
import { t } from "utilities/localization-utils";

const CSS_CLASS_NAME = "c-color-accordion-panel-header";

interface ColorAccordionPanelHeaderProps {
    color: UserBookmarkColors;
    numberOfBookmarks?: number;
    title: string;
}

const ColorAccordionPanelHeader = (props: ColorAccordionPanelHeaderProps) => {
    const { color, numberOfBookmarks, title } = props;
    const bookmarkModifier = BookmarkUtils.getColorClassName(color);

    return (
        <div className={`${CSS_CLASS_NAME}`}>
            <div className={`${CSS_CLASS_NAME}__image`}>
                <Icon cssClassName={bookmarkModifier} type={Icons.Bookmark} />
            </div>
            <div className={`${CSS_CLASS_NAME}__text`}>
                <Heading
                    cssClassName={`${CSS_CLASS_NAME}__title`}
                    priority={HeadingPriority.Four}>
                    {title}
                </Heading>
                <Paragraph
                    cssClassName={`${CSS_CLASS_NAME}__bookmarkCountSubtitle`}>
                    {t(
                        numberOfBookmarks === 1
                            ? "bookmarkWithCount"
                            : "bookmarkWithCount_plural",
                        { count: numberOfBookmarks }
                    )}
                </Paragraph>
            </div>
        </div>
    );
};

export default ColorAccordionPanelHeader;
